import { render } from "./ProductInformation.vue?vue&type=template&id=1cd09eb4"
import script from "./ProductInformation.vue?vue&type=script&lang=js"
export * from "./ProductInformation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/Microfrontends/devices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__